// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__pph3E","buttons":"SendReceipts_buttons__J1w-f","email":"SendReceipts_email__3AgZi","bookApptTitle":"SendReceipts_bookApptTitle__21r_p"};